<template>
    <div class="calendar-popup"  v-on:mouseup="EndDrag()" v-bind:style="{top: posy + 'px', left: posx + 'px', display: toggled ? 'inline-block' : 'none'}">
        <div class="background" v-on:click="Close()"></div>
        <div class="pointer" v-bind:class="[pointerDirection]" v-bind:style="{left: pointerOffsetX, top: pointerOffsetY}"></div>
        <div class="header">
            <div class="label"></div>
        </div>
        <div class="fa-stack cancel" v-on:click="Toggle(false)">
            <i class="fas fa-circle fa-stack-2x"></i>
            <i class="fas fa-times fa-stack-2x"></i>
        </div>
        <div class="entry header">
            <div class="fa-stack left" v-on:click="SwitchDate(date.clone().add(-1,'days'))">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-left fa-stack-2x"></i>
            </div>
            <div class="fa-stack right" v-on:click="SwitchDate(date.clone().add(1,'days'))">
                <i class="fas fa-circle fa-stack-2x"></i>
                <i class="fas fa-angle-right fa-stack-2x"></i>
            </div>
            <div class="label bold">{{date.format('dddd')}},</div>
            <div class="label">{{date.format('DD')}}. {{date.format('MMMM YYYY')}}</div>
        </div>
        <div class="entry event">
            <div class="label">{{event ? event.header : ''}}</div>
        </div>
        <div class="employee" v-for="(employee, indexE) in employees" :key="indexE" v-if="timeFrames[employee.id]" v-bind:class="{approved: timeFrames[employee.id].every(t => t.preference.approved)}">
            <div class="picture" v-bind:style="{background: (employee !== null ? employee.displayData.picture : 'url(../img/default.jpg)'), 'background-size': 'contain'}"></div>
            <div class="name">{{employee.displayData.name}}</div>
            <div class="time-table">
                <div class="timeframe" v-for="(timeFrame, indexF) in timeFrames[employee.id]" :key="indexF" v-bind:style="[GetTimeFrameStyles(timeFrame)]" v-bind:id="timeFrame.preference.id" v-bind:class="{approved: timeFrame.approved}">
                    <div class="label">{{timeFrame.preference.fromDate.format('MM/DD HH:mm') + ' - ' + timeFrame.preference.toDate.format('MM/DD HH:mm')}}</div>
                    <div class="time-marks">
                        <div class="mark" v-for="(mark, indexMark) in timeFrame.timeMarks" :key="indexMark" v-bind:style="{width: mark.width, background: mark.darkBackground ? '#ccc' : '#e5e5e5'}">
                        </div>
                    </div>
                    <div class="bar-container">
                        <div class="bar" v-bind:style="GetTimeFrameBarStyles(timeFrame.preference, timeFrame.monthScale)">
                        </div>
                    </div>
                    <div class="return backward">
                        <div class="fa-stack" v-on:click="ToggleMonthScale(timeFrame)">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-stack-2x fa-angle-left"></i>
                        </div>
                    </div>
                    <div class="return forward">
                        <div class="fa-stack" v-on:click="ToggleMonthScale(timeFrame)">
                            <i class="fas fa-circle fa-stack-2x"></i>
                            <i class="fas fa-stack-2x fa-angle-right"></i>
                        </div>
                    </div>
                    <i class="fas fa-times-circle checkbox decline" v-on:click="deleteEmployeePreference(timeFrames[employee.id].preference)"></i>
                    <i class="fas fa-check-circle checkbox approve" v-on:click="approveEmployeePreference(timeFrames[employee.id].preference)"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'calendarinfo',
        components: {
        },
        data(){
            return{
                toggled: false,
                posxstart: 0,
                posystart: 0,
                posx: 0,
                posy: 0,
                width: 0,
                height: 0,
                appendedData: {},
                pointerDirection: 'top',
                elRelative: null,
                date: this.$helpers.getMomentUTC(),
                event: {header: ''},
                pointerOffsetX: '',
                pointerOffsetY: '',
                mouse: {x: 0, y: 0},
                barDragging: null,
                dragStart: {x: 0, y: 0},
                employees: [],
                timeFrames: {}
            }
        },
        created () {
            var view = this;
            this.toggled = false;
            window.addEventListener('resize', this.Reposition);
        },

        mounted () {
            var view = this;
        },

        props: {
            state: Object
        },
        watch: {
            state: {
                //deep: true, //this causes "maybe infinite loop" error on console
                immediate: true,
                handler(newVal, oldVal){
                    for(var x in newVal) this[x] = newVal[x];
                    if(newVal.toggled){
                        this.Init();
                    }
                }
            }
        },
        update(){
        },

        beforeDestroyed(){
            this.$el.removeEventListener('mousemove', this.TrackMouse);
        },
        destroyed(){
            window.removeEventListener('resize', this.Reposition);
        },
        methods: {
            GetTimeFrameStyles(timeFrame){
                if(!timeFrame.fromDate || !this.date || !timeFrame.toDate) return {};
                var totalWidth = $(this.$el).width();
                var timePixelRatio = totalWidth / this.timeFrameLength;
                var styles = {
                    width: (this.TimeDiff(timeFrame.fromDate, timeFrame.toDate) * timePixelRatio) + 'px',
                    left: (this.TimeDiff(this.date, timeFrame.fromDate) * timePixelRatio) + 'px',
                    background: this.GetColorForState(timeFrame.preference.state),
                    };
                    return styles;
            },
            GetColorForType(typeId){
                if(typeId === 1) return '#e76e13'; //vacation
                if(typeId === 2) return '#e51650'; //sickness
                if(typeId === 3) return '#e5c420'; //holiday
                if(typeId === 4) return '#7e1433'; //miscellaneous
                if(typeId === 4) return '#808080'; //no contract
            },
            GetColorForState(stateId){
                if(stateId === 1) return '#e51650'; //unavailable
                if(stateId === 2) return '#294285'; //only available
                if(stateId === 3) return '#ff1655'; //undesired
                if(stateId === 4) return '#aace27'; //desired
            },
            TimeDiff(a, b){
                return (parseInt(b.format('x'))) - (parseInt(a.format('x')));
            },
            GetTimeFrameBarStyles(preference, monthScale){
                var width = '0%';
                var left = '0%';
                if(monthScale) {
                    var days = preference.fromDate.daysInMonth();
                    left = ((this.TimeDiff(preference.fromDate.clone().date(0).hours(0), preference.fromDate) / (days * 24 * 60 * 60 * 1000)) * 100)  + '%';
                    width = ((this.TimeDiff(preference.fromDate, preference.toDate) / (days * 24 * 60 * 60 * 1000)) * 100)  + '%';
                } else {
                    left = ((this.TimeDiff(preference.fromDate.clone().hours(0), preference.fromDate) / (48 * 60 * 60 * 1000)) * 100) + '%';
                    width = ((this.TimeDiff(preference.fromDate, preference.toDate) / (48 * 60 * 60 * 1000)) * 100)  + '%';
                }
                return {
                    width: width,
                    left : left,
                };
            },
            GetProfilePictureUrl(employee){
                if(!employee || !employee.employeePicture || !employee.employeePicture.server) return 'var(--contrast-1) no-repeat center/cover  url(../img/default.jpg)';
                var d = new Date();
                return 'var(--contrast-1) no-repeat center/cover  url(' + employee.employeePicture.server + '/api/file?id='+ employee.employeePicture.fileId +'&accessToken='+employee.employeePicture.accessToken +"&thumb=small"+ '&time='+Date.now()+')';
            },
            StartDrag(bar){
                this.barDragging = bar;
                this.dragStart = {x: this.mouse.x, y: this.mouse.y};
                this.startDragIncome = bar.entry.income;
            },
            EndDrag(){

                if(this.barDragging === null) return;
                var view = this;
                this.barDragging = null;
            },
            Close(){
                if($(window.mouse.element).closest('.weather-popup').length > 0) return;
                this.Toggle(false);
            },
            Toggle(val){
                if(val !== undefined || val !== null) {
                    if(!val) this.selected = null;
                    this.toggled = val;
                    return;
                }
                this.toggled = !this.toggled;
                if(!this.toggled) this.selected = null;
            },
            Reposition(){
                var view = this;
                var boxPopup = this.$el.getBoundingClientRect();

                var userselectheight = boxPopup.height;
                requestAnimationFrame(function(){
                    if(!view.elRelative) return;
                    var box = view.elRelative.getBoundingClientRect();
                    var widthTotal = window.innerWidth;
                    var heightTotal = window.innerHeight;
                    var posx = 0;
                    var posy = 0;
                    var userselectwidth = 400;
                    var offsety = 20;
                    var offsetyBottom = 70;
                    view.pointerOffsetX = '';
                    if(widthTotal - (box.left + (box.width / 2)) > (userselectwidth / 2)) {
                        posx = (box.left + (box.width / 2)) - (userselectwidth / 2);
                    } else {
                        requestAnimationFrame(function(){
                            var popupBox = view.$el.getBoundingClientRect();
                            var pointerBox = $(view.$el).find('.pointer')[0].getBoundingClientRect();
                            var pointerOffsetX = (((box.left + (box.width / 2)) - ((popupBox.left + popupBox.right) / 2)) / .4);
                            if(pointerOffsetX + (pointerBox.width + 20) > (userselectwidth)) pointerOffsetX = (userselectwidth) - (pointerBox.width  + 20);
                            view.pointerOffsetX = pointerOffsetX + 'px';
                        });
                        if(box.left < 150 || widthTotal < (userselectwidth / 2)) {
                            posx = 5;
                        } else {
                            posx = widthTotal - userselectwidth - 5;
                        }
                    }
                    var pointerDirection = 'top';
                    if(heightTotal - (box.top + box.height + offsety) > userselectheight) {
                        posy = (box.top + box.height + offsety);
                    } else {
                        if(heightTotal < userselectheight || box.top - offsetyBottom - userselectheight < 0) {
                            posy = 5;
                            pointerDirection = 'hide';
                        } else {
                            posy = box.top - userselectheight;
                            pointerDirection = 'bottom';
                        }
                    }
                    view.posx = posx;
                    view.posy = posy;
                    view.pointerDirection = pointerDirection;
                    view.$forceUpdate();
                });
            },
            ChangeDate(newDate){
                    if(this.rawData.filter(d => moment.unix(d.dt).date() === newDate.date()).length === 0) return;
                    this.date = newDate;
                    this.date.locale('de');

                    this.InitData();
            },
            ToggleMonthScale(timeFrame){
                timeFrame.monthScale = !timeFrame.monthScale;
                timeFrame.timeMarks = this.GetTimeMarks(timeFrame.preference, timeFrame.monthScale);
                this.$forceUpdate();
            },
            Init(){
                var view = this;
                view.employees = view.employees.filter(e => view.preferences.find(p => p.employeeId === e.id));
                this.timeFrames = {};
                this.employees.forEach(e => {
                    view.preferences.filter(p => p.employeeId === e.id && p.date.month() === view.date.month() && p.date.date() === view.date.date()).forEach(p => {
                        if(!view.timeFrames[e.id]) view.timeFrames[e.id] = [];
                        var fromDate = view.$helpers.getMomentFromStringUTC(p.from, 'YYYY-MM-DDTHH:mm');
                        var toDate = view.$helpers.getMomentFromStringUTC(p.to, 'YYYY-MM-DDTHH:mm');
                        var monthScale = (view.TimeDiff(fromDate, toDate) > 48 * 60 * 60 * 1000);
                        var timeMarks = view.GetTimeMarks(p, monthScale);
                        view.timeFrames[e.id].push({
                            preference: p,
                            fromDate: fromDate,
                            toDate: toDate,
                            timeMarks: timeMarks,
                            monthScale: monthScale,
                        });
                    });
                });
                this.employees.sort((a,b) => {return (view.timeFrames[a.id].find(t => t.preference.approved) ? 1 : -1) - (view.timeFrames[b.id].find(t => t.preference.approved) ? 1 : -1)});
                requestAnimationFrame(function () {
                    view.Reposition();
                });
            },
            GetTimeMarks(preference, monthScale){
                var marks = [];
                if(monthScale) {
                    var days = preference.fromDate.daysInMonth();
                    for (var x = 0; x < days ; x++) {
                        var tempDate = preference.fromDate.clone().add(x, 'day');
                        marks.push({width: 'calc(100% / ' + days +')', label: x, darkBackground: tempDate.weekday() === 0 || tempDate.weekday() === 6}); //darkBackground: preference.fromDate.clone().add(x, 'hours').date() !== preference.fromDate.date()});
                    }
                } else {
                    for (var x = 0; x < 48; x++) {
                        marks.push({width: 'calc(100% / 48)', label: x, darkBackground: x > 23}); //darkBackground: preference.fromDate.clone().add(x, 'hours').date() !== preference.fromDate.date()});
                    }
                }
                return marks;
            },
            OnDeletePreference(preference){},
            SwitchDate(date){},
            deleteEmployeePreference: function(preference){
                let view = this;
                let url = '/api/sec/employeepreference';

                url = this.$helpers.appendParam("id", preference.id, url, '/api/sec/employeepreference');
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference');


                this.axios({
                    method: 'delete',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    view.preferences = view.preferences.filter(p => p.id !== preference.id);
                    view.employees = view.employees.filter(e => view.preferences.find(p => p.employeeId === e.id));
                    view.Init();
                    view.$forceUpdate();
                    if(view.state.OnDeletePreference) view.state.OnDeletePreference(preference);
                }).catch(function (error) {
                })

            },
            approveEmployeePreference: function(preference){
                let view = this;
                let url = '/api/sec/employeepreference/approve';
                url = this.$helpers.appendParam("storeId", this.$store.state.storeId, url, '/api/sec/employeepreference/approve');

                let payload = {id: preference.id, certain: preference.approveCertain, factor: preference.factor};

                this.axios({
                    method: 'put',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url,
                    data: payload
                }).then(response => {
                    preference.approved = true;
                    view.$forceUpdate();
                }).catch(function (error) {
                    console.log(error)
                })

            },
        },
        mounted() {
            $('body').append(this.$el);
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .calendar-popup{
        position:fixed;
        display:inline-block;
        width: 500px;
        border-radius: 5px;
        display:none;
        z-index: 1000;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        padding: 40px;
        padding-top: 30px;
    }
    .calendar-popup.daily{
        height: 720px;
    }


     .background {
        position: fixed;
        height: 100vh;
        width: 100vw;
        left: 0;
        right: 0;
        z-index: -1;
        top: 0;
    }




    .header{
    }
    .header .label{
        box-shadow: inset 0 -1px 0 0px #ebebeb;
        font-size: 30px;

    }

    .fa-stack.cancel{
        cursor: pointer;
        position: absolute;
        top: 6px;
        right: 5px;
        font-size: 10px;
        transform: scale(.8);
    }
    .fa-stack.cancel .fa-circle{
    }
    .fa-stack.cancel .fa-times{
        font-size: 13px;
        transform: translateY(3px);
    }

    .weather-popup > .label{
        color: #cccccc;
        font-size: 11px;
        font-weight: 500;
        position: absolute;
        margin-top: -10px;
    }
    .weather-popup > .label.second{

        margin-top: 5px;
    }


    .label{
        background: white;
    }

    .entry .label{

        font-weight: 200;
    }
    .entry > .label{
        padding: 0 5px;
    }
    .entry{
        width: 100%;
        text-align: center;
        display: table;
        position: relative;
    }

    .entry.header{
        box-shadow: none;
        float: none;
        margin-top: 15px;
    }

    .entry.header .fa-stack{

    }

    .entry.header .label{
        box-shadow: none;
        color: #404040;
        float: none;
        font-size: 14px;
        font-family: DistrictProLight;
        letter-spacing: 0.2px;
        margin-left: -6px;
    }

    .entry.header .label.bold{
        font-weight: 700;
        font-family: DistrictProBold;
        letter-spacing: 1.2px;
        margin-left: -5px;
    }

    .entry.icon{
    }
    .entry.icon .picture{
        height: 80px;
        margin-top: -40px;
    }
    .entry.icon .label{
        font-size: 60px;
        font-family: DistrictProLight;
        color: #808080;
        margin: 7px 0px 10px 5px;
        letter-spacing: 0px;
        font-weight: 200;
    }

    .entry.variation{
    margin-top: 5px;
    letter-spacing: -0.2px;
    }

    .entry.event{
        margin-top: 5px;
        letter-spacing: 0.6px;
    }

    .entry.event .label{

        font-size: 10px;
    transform: translateY(-1px);
    }

    .entry.hourly{
    padding-top: 13px;

    }
    .entry.hourly .slot{
        width: 24px;
        margin: 0 3.5px;
        display: inline-block;
    }
    .entry.hourly .slot > *{
        float: left;
    }

    .entry.hourly .slot .hour{

    }
    .entry.hourly .slot .super{
        font-size: 8px;
        transform: translate(1px, -2px);
    }
    .entry.hourly .slot .picture{
        height: 17px;
    margin: 3px 0 10px;

    }
    .entry.hourly .slot .temp{

    margin-top: 4px;
    }
    .entry.hourly .slot .rain{
        color: #08a1e4;
        font-size: 9px;

    font-size: 9px;
    height: 10px;
    width: 100%;
    }

    .entry.nav{
        margin: 12px 0;
    }
    .entry.nav .fa-stack{
        transform: scale(0.45);
    }

    .entry.nav .left{
        left: -25px;
        right: 0;
        top: 1px;
        bottom: 0;
        margin:auto;
        background: white;
        width: 75px;
        cursor: pointer;
    }
    .entry.nav .right{
        right: -25px;
        left: 0;
        top: 1px;
        bottom: 0;
        margin:auto;
        background: white;
        width: 75px;
        cursor: pointer;
    }
    .entry.nav .fa-angle-right, .entry.nav .fa-angle-left{
        pointer-events:none;
    }

    .entry.info{
        margin-top: 25px;
        position: absolute;
        bottom: 55px;
        width: 50%;
    }

    .entry.info .label{
        font-family: DistrictProLight;
        width: 100%;
    letter-spacing: 0.3px;
    margin-left: 7px;
        color: #cccccc;
        font-size: 8px;
        white-space: nowrap;
        font-weight: 500;
        display: block;
        margin-bottom: 2px;
    background: none;
    }

    .entry.location .label, .entry.variation .label, .entry.hourly .label.hour, .entry.hourly .label.temp, .entry.nav .label {
        font-size: 11px;
        color: #808080;
    }

    .left{
        position:absolute;
        margin: 0;
        top: 0px;
        transform: scale(0.7);
        left: 0;
        cursor:pointer;
    }
    .right{
        position:absolute;
        margin: 0;
        top: 0px;
        transform: scale(0.7);
        right: 0;
        cursor:pointer;
    }

    .line-through{
    top: 2px;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 1px;
        background: #c1c1c1;
        position: absolute;

        z-index: -1;
    }

    .divider{
        width: 100%;
        margin: 15px 0;
        border-bottom: 1px solid #e5e5e5;
    }

    .pointer{
        position: absolute;
        right: 0;
        left: 0;
        margin: auto;
        width: 0;
    }

    .pointer:before{
        content:'';
        position: absolute;
        top: 1px;
        left: -13px;
        z-index: -1;
        filter: blur(5px);
    }

    .pointer:after{
        content:'';
        position: absolute;
        left: -20px;
        background: white;
        width: 40px;
        height: 20px;
        z-index: -1;
    }

    .pointer.top{
        top: -15px;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid white;
    }
    .pointer.top:before{
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-bottom: 15px solid rgba(0,0,0,.2);
    }
    .pointer.top:after{
        top: 15px;
    }
    .pointer.bottom{
        bottom: -15px;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid white;
    }
    .pointer.bottom:before{
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid rgba(0,0,0,.2);
        top: initial;
        bottom: 1px;
    }
    .pointer.bottom:after{
        bottom: 15px;
    }

    .pointer.hide{
        display: none;
    }

    .circle{
        border-radius: 100px;
    }

    .circle .miniature{
        position: absolute;
        right: 0;
        left: 0;
        width: 15px;
        height: 15px;
        margin: auto;
        bottom: -20px
    }
    .circle .label{

        position: absolute;
        right: 0;
        left: 0;
        top: 0;
        bottom: 0;
        color: white;
    }

    .red{
        background: #e51c50;
    }

    .orange{
        background: #e86d1d;
    }

    .green{
        background: #6c8d25;
    }
    .empty{
        background: #e5e5e5;
    }

    .circle.top-left{
        position:absolute;
        width: 50%;
        height: 50%;
        top: 0;
        left: 0;
         border-radius: 100px 0 0 0;
    }
    .circle.top-right{
        position:absolute;
        width: 50%;
        height: 50%;
        top: 0;
        right: 0;
         border-radius: 0 100px 0 0;
    }
    .circle.bottom-left{
        position:absolute;
        width: 50%;
        height: 50%;
        bottom: 0;
        left: 0;
         border-radius: 0 0 0 100px;
    }
    .circle.bottom-right{
        position:absolute;
        width: 50%;
        height: 50%;
        bottom: 0;
        right: 0;
        border-radius: 0 0 100px 0;
    }

    .hourly > .circle{
        position:relative;
        height: 50px;
        width: 50px;
        margin: 0 10px;
        display: inline-block;
    }
    .hourly > .circle .label{
        background: none;
        font-size: 10px;
        color: white;
        text-align: center;
        width: 100%;
        margin-top: 10px;
        height: 15px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
    .daily > .circle{
        position:relative;
        height: 200px;
        width: 200px;
        margin: 40px 10px 10px;
        display: inline-block;
    }
    .daily > .circle .label{
        background: none;
        font-size: 15px;
        color: #cccccc;
        text-align: center;
        width: 100%;
        margin-top: 10px;
        height: 15px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
    .daily  .circle.top-left{
        box-shadow: inset -4px -4px 0px -2px white;
    }
    .daily  .circle.top-right{
        box-shadow: inset 4px -4px 0px -2px white;
    }
    .daily  .circle.bottom-right{
        box-shadow: inset 4px 4px 0px -2px white;
    }
    .daily  .circle.bottom-left{
        box-shadow: inset -4px 4px 0px -2px white;
    }
    .daily  .circle.top-left .label{
    top: -60%;
    bottom: 0;
    left: -140%;
    right: 0;
    }
    .daily  .circle.top-right .label{
    top: -60%;
    bottom: 0;
    left: 0;
    right: -140%;
    }
    .daily  .circle.bottom-right .label{
        top: 0;
        bottom: -50%;
        left: 0;
        right: -140%;
    }
    .daily  .circle.bottom-left .label{
        top: 0;
        bottom: -50%;
        left: -140%;
        right: 0;
    }

    .entry.daily, .entry.hourly{
        padding: 10px 0;
    }

    .scrollbar-container{
        position: relative;
        height: 220px;
        top: 0;
        margin-top: 15px;
    }

    .scrollbar-container .entry{
        cursor: pointer;
        padding: 3px 5px;
        transition: .2s;
        text-align: left;
        border-radius: 100px 0 0 100px;
    }

    .scrollbar-container .entry .circle{
        width: 16px;
        height: 16px;
        transform: translateY(1px);
        display: inline-block;
    }


    .scrollbar-container .entry .label{
        background: none;
        font-size: 15px;
        transform: translateY(-3px);
    }
    .scrollbar-container .entry .timeframe{
        margin-right: 25px;
        font-family: DistrictProBook;
    }

    .scrollbar-container .entry:nth-child(even){
        background: #e5e5e5;
    }

    .nightmode .scrollbar-container .entry:nth-child(even){
        background: var(--bg);
    }

    .scrollbar-container .entry.border-red{
        background: rgba(155, 0, 0, .3);
    }

    .scrollbar-container .entry.border-red:nth-child(even){
        background: rgba(155, 0, 0, .5);
    }


    .scrollbar-container .entry.border-green{
        background: rgba(0, 180, 0, .3)
    }

    .scrollbar-container .entry.border-green:nth-child(even){
        background: rgba(0, 180, 0, .5)
    }


    .scrollbar-container .entry:hover, .entry.selected{
        background: #6d8d23 !important;
    }

    .scrollbar-container .entry:hover .label, .entry.selected .label{
        color: white;
    }

    .scrollbar-container .entry:hover .circle{
        box-shadow: inset 0 0 0 2px white;
    }
    .scrollbar-container .entry *{
            pointer-events: none;
    }

    .calendar-popup > .button{
        position: absolute;
    bottom: 50px;
    right: 50px;
    width: 80px;
    height: 30px;
    }
    .calendar-popup > .button > .label{
        position: absolute;
        background: none;
        margin: auto;
        top: -5px;
        bottom: 0;
        left: 0;
        right: 0;
        transform: none;
        height: 15px;
        text-align: center;
        font-size: 12px;
    }

    .entry.income-list{

        padding: 5px 10px;
    }

    .entry.daily{
        padding: 15px;
    }

    .grid{
        height: 160px;
        box-shadow: inset 1px -1px 0 0px black;
        overflow: hidden;
    }

    .grid .line{
    border-bottom: 1px solid #ccc;
    margin-bottom: 2.4%;
    }

    .gray{
        background: #ccc;
    }

    .grid .bar{
        display: inline-block;
        float: left;
        -webkit-transform: translateY(-100%);
        transform: translateY(-100%)translateX(12px);
        border-radius: 10px 10px 0 0;
        width: 1.95%;
        min-height: 1%;
    }
    .grid .bar .handle{
        opacity: 0;
        -webkit-transition: .2s;
        transition: .2s;
        /* border-bottom: 2px solid #ccc; */
        cursor: pointer;
        position: absolute;
        top: -5px;
        width: 300%;
        left: -100%;
        height: 10px;
        font-size: 30px;
        line-height: 0%;
        color: #808080;
    }
    .grid .bar:hover .handle{
        opacity: 1;
        display: inline-block;
    }
    .grid .bar.gray .handle{
        /*display: none;*/
    }
    .grid .label.bottom{
        position: absolute;
        font-size: 10px;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }
    .grid .label.left{
        position: absolute;
        font-size: 10px;
        left: -13px;
        background: none;
        top: 0;
        bottom: 0;
        margin: auto;
        height: 20px;
        transform: rotate(270deg);
    }

    .amount{
        position: fixed;
        margin: auto;
        height: 30px;
        display: inline-block;
        background: white;
        box-shadow: 4px 4px 5px 3px rgba(0,0,0,0.2);
        pointer-events: none;
        width: fit-content;
        padding: 5px;
        border-radius: 5px;
        transform: translate(-50%, -125%);
        opacity: 0;
    }

    .entry > input{
        box-shadow: none !important;
        display: inline !important;
        pointer-events: initial !important;
        width: 20px;
    }

    .entry > input.timeframe{
        width: 18px !important;
        display: inline-block !important;
        margin: 0 !important;
        padding: 0;
    }
    .entry > input.timeframe:nth-child(2){
        margin-left: 5px !important;
    }
    .entry > input.timeframe:nth-child(8){
    margin-right: 29px !important;
    }
    .entry > .hour{
        display: inline-block !important;
        margin: 0 !important;
        padding: 0;
        width: 4px !important;
    }
    .entry > .divider{
        width: 5px !important;
        display: inline-block !important;
        border:none;
        padding: 0;
        margin: 0 3px 0 4px !important;
    }

    .scrollbar-container .entry .fa-stack{
        font-size: 7px;
        position: absolute;
        right: 5px;
        top: 7px;
        pointer-events: initial !important;
        cursor: pointer;
    }
    .scrollbar-container .entry:not(.input) .fa-stack{
        transition: .2s;
        opacity: 0;
    }
    .scrollbar-container .entry:not(.input):hover .fa-stack{
        opacity: 1;
    }
    .scrollbar-container .entry .fa-stack .fa-circle{
    }
    .scrollbar-container .entry .fa-stack .fa-plus,.entry .fa-stack .fa-times{
        transform: scale(.8);
    }

    .amount.selection{
        pointer-events: initial;
        padding: 0;
        overflow: hidden;
        height: initial;
        opacity: 1;
        z-index: 2;
    }

    .amount.selection .label{
        padding: 5px;
        font-size: 15px;
        margin: 0;
        color: black;
        letter-spacing: initial;
        cursor: pointer;
        display: block;


    }
    .amount.selection .label:hover{
        background: #6c8d25;
        color: white;
    }

    .nightmode .pointer:after{
        background: var(--sub-menu);
    }

    .nightmode .pointer.top{
        border-bottom: 15px solid var(--sub-menu);
    }
    .nightmode .pointer.bottom{
        border-top: 15px solid var(--sub-menu);
    }


    .nightmode .left, .nightmode .right{
        background: var(--sub-menu) !important;
    }


    .nightmode .calendar-popup{
        background: var(--sub-menu);
    }



    .nightmode .label{
        background: var(--sub-menu);
        color: var(--contrast-4) !important;
    }

    .time-table{
    }

    .return{
        position: absolute;
        left: -17px;
        top: 2px;
        z-index: 4;
        width: 15px;
        height: 15px;
    }
    .return.forward{
        right: -17px;
        left: initial;
    }

    .return .fa-stack{
        transform: scale(.35);
        transition: .2s;
        position: absolute;
        left: 0;
        top: 0;
        left: -12px;
        top: -12px;
    }
    .return .fa-stack .fa-circle{
        color: var(--contrast-6);
    }

    .employee{
        position: relative;
        width: 100%;
        box-shadow: inset 0px 2px 0 -1px rgba(0,0,0,.2);
        padding-bottom: 10px;
    }
    .employee:last-child{
        box-shadow: inset 0px 2px 0 -1px rgba(0,0,0,.2),inset 0px -2px 0 -1px rgba(0,0,0,.2);
    }

    .employee .picture {
        background-size: 100%;
        position: absolute;
        height: 30px;
        width: 30px;
        left: 5px;
        top: 7px;
        border-radius: 33px;
    }

    .employee .name {
        font-size: 13px;
        color: var(--contrast-5);
        text-align: left;
        height: 15px;
        white-space: nowrap;
        font-weight: 800;
        margin-top: 5px;
        margin-left: 0px;
        font-family: DistrictProBold;
        left: 45px;
        position: absolute;
    }

    .time-table{
        position: relative;
        display: inline-block;
        width: 40%;
        left: 45%;
        background: #e5e5e5;
        height: 13px;
        top: 10px;
    }

    .decline{
        position: absolute;
        top: -1px;
        right: -35px;
        transform: scale(.8);
    }

    .approve{
        position: absolute;
        top: -1px;
        right: -50px;
        transform: scale(.8);
    }

    .employee .timeframe .label{
        width: 100%;
        background: none;
        position: absolute;
        bottom: -20px;
        left: 0;
        text-align: center;
    }

    .time-table .fas{
        cursor: pointer;
    }

    .employee .approve, .employee .decline{
        color: #ccc;
    }

    .employee .approve:hover{
        color: #6c8d25;
    }
    .employee .decline:hover{
        color: #e5154f;
    }

    .approved .fas{
        pointer-events: none;
    }

    .employee.approved .approve{
        color: #6c8d25;
    }

    .employee:not(.approved) *:not(.fas){
        color: #e5c420;
    }

    .employee.approved *:not(.fas){
        color: #6c8d25;
    }

    .employee:not(.approved) .bar{
        background: #e5c420;
    }

    .employee.approved .bar{
        background: #6c8d25;
    }



    .time-marks{
        pointer-events: none;
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        padding: 0;
        white-space: nowrap;
        top: -5px;

    }

    .time-marks .label{
        position: absolute;
        top: -20px;
        left: -15px;
        width: 30px;
        z-index: 10;
        text-align: center;
    }

    .time-marks .mark{
        text-align: center;
        position: relative;
        width: calc(100% / 24);
        height: 100%;
        display: inline-block;
        background: none;
        top: 0;
        padding: 0;
    }

    .timeframe .bar{
        position: absolute;
        border-radius: 50px;
        height: 50%;
        bottom: 0;
        z-index: 11;
    }

    .timeframe{
        position: relative;
        margin-bottom: 20px;
        display: inline-block;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
    }

    .timeframe .bar-container{
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
</style>
